// ErrorCode should reflect the backend error_codes.go
export type ErrorCode =
  | "Tracked"
  | "NotFound"
  | "Validation"
  | "InvalidAPIVersion"
  | "MethodNotAllowed"
  | "Forbidden"
  | "Conflict"
  | "Unauthorized"
  | "BadRequest"
  | "Conversion"
  | "NotAcceptable"
  | "Readonly"
  | "PlanRestricted"
  | "UnverifiedAccount"
  | "NotOnboardedAccount";

export function GetFullErrorMessage(message: string) {
  return message;
}

export class ExposedError extends Error {
  public code: ErrorCode;

  constructor(payload: any) {
    super(payload.message);
    this.code = payload.code;
  }

  // FullMessage returns the error message.
  // if the message, can be found in locales/en/errors.json it  will return the value
  // for the key otherwise it will return the message from the server
  get fullMessage() {
    return GetFullErrorMessage(this.message);
  }
}

export function isExposedError(error: any): error is ExposedError {
  return error instanceof ExposedError;
}

export class ValidationError extends ExposedError {
  public fields: Record<string, string>;

  constructor(payload: any) {
    super(payload);
    this.fields = payload.fields;
  }
}

export function isValidationError(error: any): error is ValidationError {
  return error instanceof ValidationError;
}

export class ConversionError extends ExposedError {
  public field: string;

  constructor(payload: any) {
    super(payload);
    this.field = payload.field;
  }
}

export function isConversionError(error: any): error is ConversionError {
  return error instanceof ConversionError;
}

export class ConflictError extends ExposedError {
  public field: string;

  constructor(payload: any) {
    super(payload);
    this.field = payload.field;
  }
}

export function isConflictError(error: any): error is ConflictError {
  return error instanceof ConflictError;
}

export class TrackedError extends Error {
  public tracking_code: string;

  constructor(payload: any) {
    super(payload.message);
    this.tracking_code = payload.tracking_code;
  }
}

export function isTrackedError(error: any): error is TrackedError {
  return error instanceof TrackedError;
}
